var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-splited-view"},[(_vm.$slots.left)?_c('div',{staticClass:"app-splited-view__left"},[_vm._t("left")],2):_vm._e(),(_vm.$slots.right)?_c('div',{staticClass:"app-splited-view__right"},[_vm._t("right")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }